import { Routes, Route, Navigate } from 'react-router-dom'
import { useAuth } from './context/AuthContext.jsx'
import Layout from './components/Layout.jsx'
import Login from './pages/auth/Login.jsx'
import AcceptInvite from './pages/auth/AcceptInvite.jsx'
import EmailAccountsList from './pages/accounts/EmailAccountsList.jsx'
import AddEmailAccount from './pages/accounts/AddEmailAccount.jsx'
import GoogleConnector from './pages/accounts/GoogleConnector.jsx'
import IMAPConnector from './pages/accounts/IMAPConnector.jsx'
import Templates from './pages/template/Templates.jsx'
import CreateTemplate from './pages/template/CreateTemplate.jsx'
import CustomEmailBuilder from './pages/builder/CustomEmailBuilder.jsx'
import Campaigns from './pages/campaigns/Campaigns.jsx'
import AddMainCampaign from './pages/campaigns/AddMainCampaign.jsx'
import AICreateCampaign from './pages/campaigns/AICreateCampaign.jsx'
import Analytics from './pages/campaigns/Analytics.jsx'
import Leads from './pages/campaigns/Leads.jsx'
import Sequence from './pages/campaigns/Sequence.jsx'
import Schedule from './pages/campaigns/Schedule.jsx'
import Options from './pages/campaigns/Options.jsx'
import Inbox from './pages/inbox/Inbox.jsx'
import CoPilot from './pages/copilot/CoPilot.jsx'
import Reports from './pages/reports/Reports.jsx'
import Settings from './pages/setting/Settings.jsx'
import KnowledgeBase from './pages/knowledge_base/KnowledgeBase.jsx'
import AgentSettings from './pages/agent/AgentSettings.jsx'
import AIUsage from './pages/ai-usage/AIUsage.jsx'
import CampaignCalendar from './pages/calendar/Calendar.jsx'
import Contacts from './pages/contacts/Contacts.jsx'
import AddContacts from './pages/contacts/AddContacts.jsx'
import PlacementTests from './pages/placement/PlacementTests.jsx'
import NewPlacementTest from './pages/placement/NewPlacementTest.jsx'
import PlacementTestResults from './pages/placement/PlacementTestResults.jsx'
import Dashboard from './pages/dashboard/Dashboard.jsx'
import ApiDocs from './pages/api-docs/ApiDocs.jsx'
import DNSHealth from './pages/dns-health/DNSHealth.jsx'

function ProtectedRoute({ children }) {
  const { isAuthenticated, isLoading } = useAuth()
  if (isLoading) {
    return <div className="loading-screen"><div className="loader"></div></div>
  }
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }
  return children
}

function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/accept-invite" element={<AcceptInvite />} />
      <Route path="/templates/edit/:id" element={<ProtectedRoute><CustomEmailBuilder /></ProtectedRoute>} />
      <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="email-accounts" element={<EmailAccountsList />} />
        <Route path="email-accounts/add" element={<AddEmailAccount />} />
        <Route path="accounts/connect/google" element={<GoogleConnector />} />
        <Route path="accounts/connect/imap" element={<IMAPConnector />} />
        <Route path="templates" element={<Templates />} />
        <Route path="templates/create" element={<CreateTemplate />} />
        <Route path="contacts" element={<Contacts />} />
        <Route path="contacts/add" element={<AddContacts />} />
        <Route path="campaigns" element={<Campaigns />} />
        <Route path="campaigns/add" element={<AddMainCampaign />} />
        <Route path="campaigns/ai-create" element={<AICreateCampaign />} />
        <Route path="campaigns/analytics/:id" element={<Analytics />} />
        <Route path="campaigns/leads/:id" element={<Leads />} />
        <Route path="campaigns/sequence/:id" element={<Sequence />} />
        <Route path="campaigns/schedule/:id" element={<Schedule />} />
        <Route path="campaigns/options/:id" element={<Options />} />
        <Route path="calendar" element={<CampaignCalendar />} />
        <Route path="dns-health" element={<DNSHealth />} />
        <Route path="inbox-placement" element={<PlacementTests />} />
        <Route path="inbox-placement/new" element={<NewPlacementTest />} />
        <Route path="inbox-placement/:id" element={<PlacementTestResults />} />
        <Route path="inbox" element={<Inbox />} />
        <Route path="co-pilot" element={<CoPilot />} />
        <Route path="co-pilot/:sessionId" element={<CoPilot />} />
        <Route path="reports" element={<Reports />} />
        <Route path="settings" element={<Settings />} />
        <Route path="settings/knowledge-base" element={<KnowledgeBase />} />
        <Route path="settings/agent" element={<AgentSettings />} />
        <Route path="settings/ai-usage" element={<AIUsage />} />
        <Route path="api-docs" element={<ApiDocs />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}

export default App
